export interface ToastMessage {
  id: string;
  text: string;
  tone?: 'neutral' | 'success' | 'error';
}

export function ToastHost(props: { messages?: readonly ToastMessage[] }) {
  if (!props.messages?.length) return null;
  return (
    <div className="mira-toast-host" role="status" aria-live="polite">
      {props.messages.map((message) => (
        <div className="mira-toast" data-tone={message.tone || 'neutral'} key={message.id}>{message.text}</div>
      ))}
    </div>
  );
}
